import { cn } from "@/lib/utils";
import ProjectTreeItem from "./ProjectTreeItem";
import { TableauProject, ProjectNode } from "./types";

interface ProjectTreeProps {
  projects: ProjectNode[];
  selectedProject: TableauProject | null;
  onSelectProject: (project: TableauProject) => void;
  disabledProjectIds?: Set<string>;
  /** Tooltip shown on disabled tree items. Threaded through to ProjectTreeItem. */
  disabledTooltip?: string;
  level?: number;
}

export default function ProjectTree({
  projects,
  selectedProject,
  onSelectProject,
  disabledProjectIds,
  disabledTooltip,
  level = 0,
}: ProjectTreeProps) {
  return (
    <div className={cn("al-space-y-1", level > 0 && "al-ml-6")}>
      {projects.map(project => (
        <ProjectTreeItem
          key={project.id}
          project={project}
          selectedProject={selectedProject}
          onSelectProject={onSelectProject}
          disabledProjectIds={disabledProjectIds}
          disabledTooltip={disabledTooltip}
          level={level}
          renderChildren={children => (
            <ProjectTree
              projects={children}
              selectedProject={selectedProject}
              onSelectProject={onSelectProject}
              disabledProjectIds={disabledProjectIds}
              disabledTooltip={disabledTooltip}
              level={level + 1}
            />
          )}
        />
      ))}
    </div>
  );
}
